import * as React from "react";
import {HashRouter, Route, Switch} from "react-router-dom";
import MainDesktop from "../pages/desktop/MainDesktop";
import {TestPage} from "../pages/desktop/TestPage";
import ResetPasswordPage from "../pages/desktop/ResetPasswordPage";
import {LogoutPage} from "../pages/desktop/LogoutPage";

export class ApplicationRouter extends HashRouter {

	render (): React.ReactNode {
		return (<HashRouter>
					<Switch>
						<Route exact path='/' component={MainDesktop} />
						<Route exact path='/open_document/:documentId' component={MainDesktop} />
						<Route exact path='/test' component={TestPage} />
						<Route exact path='/logout' component={LogoutPage} />
						<Route path='/test/:id' component={TestPage} />
						<Route path='/reset-password/:token' component={ResetPasswordPage} />
					</Switch>
				</HashRouter>);
	}
}
